import React, {useContext, useEffect, useState} from "react";
import { UserContext } from "../../contexts/UserContext";
import { ConquerContext } from "../../contexts/ConquerContext";
import styles from './UserPhoto.module.sass';
import cn from 'classnames';

const UserPhoto = ({data, online, fallbackToMe = false, removeOnline}) =>{

    const defaultPhoto = '/assets/User.png';

    const userContext = useContext( UserContext );
    const conquer = useContext( ConquerContext );
    const [photoUrl, setPhotoUrl] = useState( defaultPhoto );

    function isDefault(url){
        return !url || url == 'User.png';
    }

    useEffect( () => {

        function reloadAvatar(snappy){
            userContext.userData.userPhoto = snappy.userPhoto;
            setPhotoUrl( snappy.userPhoto + '?v' + Date.now() );
        }

        function doWork(){
            if( fallbackToMe ) conquer.Signal.get('SNAPPY:onSet', reloadAvatar);
        }
        doWork();

        return () => conquer.Signal.remove('SNAPPY:onSet', reloadAvatar);

    }, [data]);

    useEffect( function(){

        function doWork(){
            if( data && data.userPhoto && !isDefault( data.userPhoto ) ) return setPhotoUrl( data.userPhoto );
            if( !fallbackToMe ) return setPhotoUrl( defaultPhoto );
            if( !userContext.userData || !userContext.userData.isLogged ) return setPhotoUrl(defaultPhoto);
            if( isDefault(userContext.userData.userPhoto) ) return setPhotoUrl(defaultPhoto);
            
            setPhotoUrl( userContext.userData.userPhoto);
        }
        doWork();

    }, [ userContext.userData.userPhoto, userContext.userData.isLogged, data ]);

    function getRandomColor(){

        if( !conquer.User ) return styles.bc2;

        let ownID = conquer.User.avatarID;

        if( (data && data.avatarID == ownID) || (!data && fallbackToMe) ) return styles.bc1;
        return styles.bc2;

        let randomColor = Math.floor(Math.random() * 5) + 1;
        switch( randomColor ){
            case 1: return styles.bc1; 
            case 2: return styles.bc2; 
            case 3: return styles.bc3; 
            case 4: return styles.bc4; 
            case 5: return styles.bc5; 
        }

    }

    return (
        <div className={styles.avatarContainer}>
            <img src={photoUrl} alt='UserAvatar' className={cn(styles.photo, getRandomColor())} />
            {!removeOnline && <div className={cn(styles.status, styles.active)}/>}
        </div>
    ) 

};

export default UserPhoto;